var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 191,
    viewBox: "0 0 186 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.917252 186.224C2.53519 189.746 6.02993 192 9.87414 192L199.126 192C202.97 192 206.465 189.746 208.083 186.224C209.701 182.701 209.148 178.551 206.665 175.586L133.299 87.9512L133.299 19.9481L137.612 19.9481C143.065 19.9481 147.486 15.4825 147.486 9.97404C147.486 4.46554 143.065 1.25071e-05 137.612 1.20304e-05L123.445 1.07919e-05C123.438 1.07913e-05 123.432 -4.46805e-06 123.425 -4.46862e-06L85.5748 -7.7776e-06C85.5683 -7.77817e-06 85.5618 7.48005e-06 85.5553 7.47948e-06L71.3974 6.24176e-06C65.9442 5.76502e-06 61.5234 4.46554 61.5234 9.97403C61.5234 15.4825 65.9442 19.9481 71.3974 19.9481L75.7008 19.9481L75.7008 87.9512L2.33464 175.585C-0.147656 178.551 -0.700685 182.701 0.917252 186.224ZM95.4488 19.9481L113.551 19.9481L113.551 91.6031C113.551 93.9612 114.378 96.243 115.886 98.0436L177.844 172.052L31.1556 172.052L93.1143 98.0436C94.6217 96.243 95.4488 93.9612 95.4488 91.6031L95.4488 19.9481Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLab);
export default __webpack_public_path__ + "static/media/icon-lab.7e364aae60e5688f32af294238d41868.svg";
export { ForwardRef as ReactComponent };